import axios from 'axios';
import { CUSTOMER_SERVICE_URL } from '@/constants';

const baseApiUrl = 'services/customerservice/api/tls/payment';

export default class TlspayService {
  public getTransaction(fg_id: number): Promise<any> {
    return axios.get(baseApiUrl + '/transaction/' + fg_id).then(res => res.data);
  }

  public createTransaction(
    fg_Id: number,
    client: string,
    issuer: string,
    currency: string,
    items: string,
    lang = 'fr-fr',
    afpLockedStatus = false,
    plPay = false,
    isPay = false
  ): Promise<any> {
    const host = `${location.protocol}//${location.host}`;
    let redirect_url = `${host}/checkout/confirm/${issuer.substr(0, 2)}/${issuer}/${fg_Id}`;
    let onerror_url = `${host}/checkout/${issuer.substr(0, 2)}/${issuer}/${fg_Id}`;
    if (afpLockedStatus) {
      redirect_url = `${host}/appointment/${issuer.substr(0, 2)}/${issuer}/${fg_Id}`;
      onerror_url = `${host}/checkout/confirm/${issuer.substr(0, 2)}/${issuer}/${fg_Id}`;
    }
    // 波兰支付成功永远跳转到 checkout/confirm页面
    // Polish payment success always jumps to checkout/confirm page
    if (plPay) {
      redirect_url = `${host}/checkout/confirm/${issuer.substr(0, 2)}/${issuer}/${fg_Id}`;
    }
    if (plPay && !isPay) {
      redirect_url = `${host}/appointment-proposal/${issuer.substr(0, 2)}/${issuer}/${fg_Id}`;
    }
    const reminder_url = `${host}/checkout/${issuer.substr(0, 2)}/${issuer}/${fg_Id}`;
    const callback_url = `${CUSTOMER_SERVICE_URL}/api/tls/receipt_url/${client}/${issuer}/${fg_Id}?lang=${lang}`;
    return axios
      .post(baseApiUrl + '/transaction', null, {
        params: {
          fg_Id,
          client,
          issuer,
          currency,
          redirect_url,
          onerror_url,
          reminder_url,
          callback_url,
          items
        }
      })
      .then(res => res.data);
  }

  public downloadInvoicePdf(client: string, Uid: number, fg_id: number, transaction_id: string) {
    return axios
      .get(baseApiUrl + `/transaction/invoice/${client}/${Uid}/${fg_id}/${transaction_id}`, {
        responseType: 'blob'
      })
      .then(res => res.data);
  }
}
